import * as L from 'leaflet';
import { Thing } from '../../../model';
import { MapFilterRequiredData } from '../../../model/map-filter-required-data';
import { MapContext } from '../map.component';
import { LocationForMap, ThingForMap } from '../map.service';
import { MapFilter, MARKER_SVG } from './map-filter';

export class ConnectionStatusMapFilter implements MapFilter {

    private icons: any[] = [];
    private config: any;
    private context: MapContext;
    private rankDescriptor = [
        { 'label': 'Offline', value: 'OFFLINE', 'rank': 0, 'color': '#BDBDBD', 'clusterClass': 'cluster-offline', 'clusterSelectedClass': 'cluster-offline-selected' },
        { 'label': 'Online', value: 'ONLINE', 'rank': 1, 'color': '#39D17D', 'clusterClass': 'cluster-online', 'clusterSelectedClass': 'cluster-online-selected' }
    ];

    constructor(config: any) {
        this.config = config || {};
        this.config.label = this.config.label || "Connection Status";

        this.rankDescriptor.forEach((rd, i) => {
            this.icons.splice(i, 0,
                L.divIcon({
                    html: MARKER_SVG,
                    className: `marker-${rd.label.toLocaleLowerCase()}`,
                    iconSize: [26, 40],
                    iconAnchor: [13, 40],
                })
            );
            this.icons.push(
                L.divIcon({
                    html: MARKER_SVG,
                    className: `marker-${rd.label.toLocaleLowerCase()}-selected`,
                    iconSize: [26, 40],
                    iconAnchor: [13, 40],
                })
            );
        });
    }

    setContext(context: MapContext): void {
        this.context = context;
    }

    getConfig(): any {
        return this.config;
    }

    getRequiredData(): MapFilterRequiredData {
        const requireData = new MapFilterRequiredData();
        if (this.context == MapContext.THINGS) {
            requireData.things = true;
            requireData.locations = false;
            requireData.alerts = false;
        } else {
            requireData.things = true;
            requireData.locations = true;
            requireData.alerts = false;
        }
        return requireData;
    }

    computeRank(elements: ThingForMap[] | LocationForMap[], data: any): void {
        if (this.context == MapContext.THINGS) {
            elements.forEach(el => {
                el.rank = (el as ThingForMap).connectionStatus == 1 ? 1 : 0;
            });
        } else {
            elements.forEach(el => {
                const locationConnectionStatusMap = this.getLocationConnectionStatus(data.things)
                el.rank = locationConnectionStatusMap[el.id] || 0;
            });
        }
    }

    updateMarker(element: ThingForMap | LocationForMap, marker: any): void {
        if (element.selected) {
            marker.setIcon(this.icons[this.rankDescriptor.length + element.rank]);
        } else {
            marker.setIcon(this.icons[element.rank]);
        }
    }

    getRankDescriptors(): any[] {
        return this.rankDescriptor;
    }

    private getLocationConnectionStatus(things: Thing[]): { [locationId: string]: number } {
        const locationConnectionStatusMap: { [locationId: string]: number } = {};
        things.forEach(t => {
            const currentStatus = locationConnectionStatusMap[t.locationId];
            if (!currentStatus || currentStatus == 0) {
                locationConnectionStatusMap[t.locationId] = (t.connectionStatus == 1 || t.connectionStatus == 3) ? 1 : 0;
            }
        });
        return locationConnectionStatusMap;
    }
}